import { CONSTANTS } from "lib/constants"
import { Pencil } from "lucide-react"
import { CompanyAvatar } from "modules/shared/components/Nav/CompanyAvatar"
import { useTranslation } from "react-i18next"

type Props = {
  onChangeLogo: (logo: FileList | undefined) => void
}

export function LogoPicker({ onChangeLogo }: Props) {
  const { t } = useTranslation()
  function onPickLogo() {
    const input = document.createElement("input")
    input.type = "file"
    input.accept = CONSTANTS.acceptedImageTypes.join(",")
    input.onchange = (event) => {
      const target = event.target as HTMLInputElement
      if (target.files) onChangeLogo(target.files)
    }
    input.click()
  }

  return (
    <div className="flex items-start">
      <button
        type="button"
        className="group/logo relative cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity duration-150 rounded-2xl bg-accent border overflow-hidden p-2"
        onClick={onPickLogo}
      >
        <CompanyAvatar className="h-32 w-32 rounded-2xl text-8xl group-hover/logo:opacity-80 group-active/logo:opacity-80 group-focus/logo:opacity-80" />
        <div className="absolute top-0 left-0 w-full h-full flex gap-2 items-center justify-center transition-opacity duration-150 opacity-0 group-hover/logo:opacity-100 group-active/logo:opacity-100 group-focus/logo:opacity-100 bg-background/75">
          <Pencil className="text-foreground h-5 w-5" />
          <span className="text-foreground font-medium">{t("shared.edit")}</span>
        </div>
      </button>
    </div>
  )
}
